<template>
  <div class="error-page error-page-500">
    <img
      :src="AppNetworkImage('/error-page/logo.svg')"
      alt="Logo"
      class="logo"
    />
    <h1 class="heading-2 heading">{{ title }}</h1>
    <p class="about-err">{{ message }}</p>
    <div class="buttons d-flex">
      <router-link
        v-if="!tryAgain && !newVersionMode"
        :to="buttonLink"
        class="button button-primary button-rounded"
        >{{ buttonText }}</router-link
      >
      <a
        :to="buttonLink"
        @click.prevent="retry"
        class="button button-primary button-rounded"
        v-if="tryAgain && !newVersionMode"
      >
        Try Again
      </a>
      <a
        :to="buttonLink"
        @click.prevent="reload"
        class="button button-primary button-rounded"
        v-if="newVersionMode"
      >
        {{ newVersionCta }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "appError",
  props: {
    title: {
      type: String,
      default: "Oops!",
    },
    message: {
      type: String,
      default:
        "We’re sorry, something went wrong on our end, and we couldn’t process your request. Please try again later or contact us if the problem persists.",
    },
    buttonText: {
      type: String,
      default: "Home",
    },
    buttonLink: {
      type: String,
      default: "/",
    },
    tryAgain: {
      type: Boolean,
      default: false,
    },
    newVersionMode: {
      type: Boolean,
      default: false,
    },
    newVersionCta: {
      type: String,
      default: "Update Now",
    },
  },
  mounted() {
    try {
      this.$root.$layout.toggleFooter(false);
    } catch (e) {
      e;
    }

    if (this.newVersionMode == true) {
      this.setPageTitle(this.title);
    } else {
      this.setPageTitle("Something went wrong!");
    }
  },
  methods: {
    retry: function (e) {
      e.preventDefault();
      this.$router.go();
      return false;
    },
    goBack: function () {
      this.$router.back();
    },
    reload: function () {
      location.reload();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/pages/error-page";
</style>
<style lang="scss" scoped>
.header.scrolling {
  box-shadow: none;
  .header-buttons .icons-wrapper .phone-dropdown:after {
    display: none;
  }
}
</style>
